import { render, staticRenderFns } from "./NetflixMenu.vue?vue&type=template&id=2a02c856&scoped=true&"
import script from "./NetflixMenu.vue?vue&type=script&lang=js&"
export * from "./NetflixMenu.vue?vue&type=script&lang=js&"
import style0 from "./NetflixMenu.vue?vue&type=style&index=0&id=2a02c856&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a02c856",
  null
  
)

export default component.exports